module.exports = __webpack_public_path__ + "img/base-search-fc5fb9a2.png";